applyChange